import script from "./ExchangeRateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExchangeRateModal.vue?vue&type=script&setup=true&lang=ts"

import "./ExchangeRateModal.vue?vue&type=style&index=0&id=7045f6ea&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7045f6ea"]])

export default __exports__